import { nextTick } from 'vue'
import { dismissSiteLoader, waitForCurrentPageHero } from '@/utils/siteLoader'

export default {
  install(_app, { router, store } = {}) {
    if (!router || !store) return

    let navigationId = 0

    router.beforeEach((to) => {
      if (!to.meta?.isAdmin) navigationId += 1
      return true
    })

    const onRouteSettled = async (to) => {
      if (to.meta?.isAdmin) return

      const currentId = navigationId

      await nextTick()
      await new Promise((resolve) => {
        requestAnimationFrame(() => {
          requestAnimationFrame(resolve)
        })
      })

      if (currentId !== navigationId) return

      try {
        await waitForCurrentPageHero()
      } finally {
        if (currentId === navigationId) {
          dismissSiteLoader(store)
        }
      }
    }

    router.isReady().then(() => {
      onRouteSettled(router.currentRoute.value)
    })

    router.afterEach((to) => {
      onRouteSettled(to)
    })
  },
}
